export const GET_ALL_EARNINGS = "GET_ALL_EARNINGS";
export const GET_ALL_EARNINGS_START = "GET_ALL_EARNINGS_START";
export const GET_ALL_EARNINGS_FAILED = "GET_ALL_EARNINGS_FAILED";

export const GET_ALL_EARNINGS_SIDEBAR = "GET_ALL_EARNINGS_SIDEBAR";
export const GET_ALL_EARNINGS_START_SIDEBAR = "GET_ALL_EARNINGS_START_SIDEBAR";
export const GET_ALL_EARNINGS_FAILED_SIDEBAR = "GET_ALL_EARNINGS_FAILED_SIDEBAR";

export const RELOAD_PAGE_RESET = "RELOAD_PAGE_RESET";